import { UsersScreen } from "@/screens/control-panel/users";

/** Thin wrapper — toda lógica fica em screens/control-panel/users */
export function UsersPage() {
  return <UsersScreen />;
}
